import { takeLatest, put, call } from 'redux-saga/effects';
import * as type from '../../redux/types/trans';
import Api from '../../services/trans/trans';
//import { selectedRIData } from '../../redux/actions/trans/authAction';

let allApi = new Api();

export function* saveSchemeCode(data) {
    yield put({ type: type.CAT_SAVE_SCHEMECODE, payload: data })
}

export function* selectedRIData(data) {
    yield put({ type: type.SELECTED_RI_DATA, payload: data })
}

export function* RIStatus(data) {
    yield put({ type: type.RIStatus, payload: data })
}
